import React from "react";
import styles from "./patientsrecord.module.css";
import Backicon from "../../../shared/components/Backicon/Backicon";
import Header from "../../../shared/components/Header/Header";
import basestyles from "../../../shared/styles/basestyles.module.css";
import RecordBtn from "../../../shared/components/Button/RecordBtn";
import Modal from "react-modal";

Modal.setAppElement("#root");
class PatientsRecord extends React.Component {
  state = {
    patientdetailsdata: "",
    modalIsOpen: false,
    completePatientDetails: [],
    modalData: "",
    modalType: "",
  };
  openModal(modalData, modalType) {
    this.setState({ modalIsOpen: true, modalData, modalType });
  }
  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  componentDidMount() {
    let completePatientDetails = [];
    let patientDetails = JSON.parse(
      localStorage.getItem("patient_personal_info")
    );
    let healthReports = JSON.parse(localStorage.getItem("health_report_info"));
    for (let i = 0; i < patientDetails.existingPatientData.length; i++) {
      let data = {
        patientInfo: patientDetails.existingPatientData[i],
        healthReport: healthReports.existingHealthReports[i],
      };
      completePatientDetails.push(data);
    }

    this.setState({
      completePatientDetails,
    });
  }

  renderModal = () => {
    if (this.state.modalType === "PATIENT_INFO") {
      return (
        <>
          <h1 className={styles.modalheading}>Patient Details</h1>
          <div className={styles.modalstyle}>
            <h4>First Name:</h4>
            <p>{this.state.modalData.FirstName}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Last Name:</h4>
            <p>{this.state.modalData.LastName}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Phone:</h4>
            <p>{this.state.modalData.PhoneNumber}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Date Of Birth:</h4>
            <p>{this.state.modalData.DateOfBirth}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Street Address:</h4>
            <p>{this.state.modalData.StreetAddress}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Street Address 2:</h4>
            <p>{this.state.modalData.StreetAddress2}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>City:</h4>
            <p>{this.state.modalData.City}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>State:</h4>
            <p>{this.state.modalData.State}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>ZipCode:</h4>
            <p>{this.state.modalData.ZipCode}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Country:</h4>
            <p>{this.state.modalData.Country}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Home Phone:</h4>
            <p>{this.state.modalData.HomePhoneNumber}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Hepetitis, MMR, B-vacc:</h4>
            <p>{this.state.modalData.Hepetitis_MMR_B_vacc}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Medical History:</h4>
            <p>{this.state.modalData.Significant_Medical_History}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Medication taken regularly:</h4>
            <p>{this.state.modalData.List_any_medication_taken_regularly}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Allergies:</h4>
            <p>{this.state.modalData.Allergies}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Do You Have Medical Insurance:</h4>
            <p>{this.state.modalData.DoYouHaveMedicalInsurance}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Name Of Insurance Company:</h4>
            <p>{this.state.modalData.NameOfInsuranceCompany}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Insurance Company Address:</h4>
            <p>{this.state.modalData.InsuranceCompanyAddress}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Insurance Company Address 2:</h4>
            <p>{this.state.modalData.InsuranceCompanyAddress2}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Insurance Company City:</h4>
            <p>{this.state.modalData.InsuranceCompanyCity}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Insurance Company State:</h4>
            <p>{this.state.modalData.InsuranceCompanyAddressState}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Insurance Company Zipcode:</h4>
            <p>{this.state.modalData.InsuranceCompanyZipcode}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Insurance Company Country:</h4>
            <p>{this.state.modalData.InsuranceCompanyCountry}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Policy Number:</h4>
            <p>{this.state.modalData.PolicyNumber}</p>
          </div>
          <div className={styles.modalstyle}>
            <h4>Policy Expiry Date:</h4>
            <p>{this.state.modalData.PolicyExpiryDate}</p>
          </div>
          <RecordBtn
            btnName="Close"
            onClick={() => this.closeModal()}
            style={{
              padding: "10px 50px",
              margin: "10px",
              fontSize: "1.1rem",
            }}
          />
        </>
      );
    }
    if (this.state.modalType === "HEALTH_REPORT") {
      return (
        <>
          <h1 className={styles.modalheading}>Patient Health Report</h1>
          <div className={styles.modalstyle}>
            <h3>Name - </h3>
            <p> {this.state.modalData.Name} </p>
          </div>
          <div className={styles.modalstyle}>
            <h3>Age -</h3>
            <p> {this.state.modalData.Age}</p>
          </div>
          <div className={styles.modalstyle}>
            <h3>Phone - </h3>
            <p>{this.state.modalData.Phone}</p>
          </div>
          <h3>Past Medical History - </h3>
          <p>{this.state.modalData.PastMedicalHistory}</p>
          <h3>Medications Used Before - </h3>
          <p>{this.state.modalData.MedicationsUsedBefore}</p>
          <h3>Diagnostic Testing -</h3>
          <p>{this.state.modalData.DiagnosticTesting}</p>
          <h3>Treatment Advised - </h3>
          <p>{this.state.modalData.TreatmentAdvised}</p>

          <RecordBtn
            btnName="Close"
            onClick={() => this.closeModal()}
            style={{
              padding: "10px 50px",
              margin: "10px",
              fontSize: "1.1rem",
            }}
          />
        </>
      );
    }
  };

  render() {
    return (
      <>
        <div className={styles.backgroundpic}>
          <Backicon
            onClick={() => this.props.history.goBack()}
            style={{
              background:
                "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
              color: "white",
            }}
          />
          <div className={basestyles.inputWidth}>
            <Header name="Patient Personal Details" />
            <div className={styles.patientRecord}>
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Patient Name</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.completePatientDetails &&
                    this.state.completePatientDetails.map((patient, index) => (
                      <tr key={index}>
                        <td>{index}</td>
                        <td>
                          {patient.patientInfo.FirstName}{" "}
                          {patient.patientInfo.LastName}
                          <RecordBtn
                            btnName="Patient Details"
                            onClick={() =>
                              this.openModal(
                                patient.patientInfo,
                                "PATIENT_INFO"
                              )
                            }
                          />
                          <Modal
                            isOpen={this.state.modalIsOpen}
                            style={{
                              overlay: {
                                background:
                                  "linear-gradient( 60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
                              },
                              content: {
                                color: "#091135",
                                maxWidth: "600px",
                                margin: "0 auto",
                              },
                            }}
                          >
                            {this.renderModal()}
                          </Modal>
                          <RecordBtn
                            btnName="Patient Health Report"
                            onClick={() =>
                              this.openModal(
                                patient.healthReport,
                                "HEALTH_REPORT"
                              )
                            }
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PatientsRecord;
